<template>
  <div class="PageUserRegister">
    <v-container>
      <v-row justify="center">
        <v-col cols="12" sm="8" md="6">
          <v-card class="pa-4">
            <v-card-title class="text-h5 mb-2">Cadastro</v-card-title>
            <v-card-subtitle class="mb-4">
              Registre crises e acompanhe o histórico do seu dependente de forma simples.
            </v-card-subtitle>
            <form-register-user />
            <div class="text-center mt-4">
              <span class="body-2 grey--text">É médico? </span>
              <router-link to="/register/doctor" class="body-2">Cadastre-se como médico</router-link>
            </div>
            <div class="text-center mt-2">
              <span class="body-2 grey--text">Já tem conta? </span>
              <router-link to="/login" class="body-2">Fazer login</router-link>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import FormRegisterUser from '../forms/FormRegisterUser.vue'
export default {
  name: 'PageUserRegister',
  components: { FormRegisterUser }
}
</script>
